<template>
  <el-dialog
    v-loading="isLoading"
    title="来款确认分配"
    :visible.sync="isShow"
    width="1000px"
    top="15px"
    @close="closeDoalog"
  >
    <el-form class="form-wrap">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            原合同编号：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.reOldContractNum || '' }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            项目名称：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.reProjectName || '' }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            供货单位：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.reSupplyUnit || '' }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            订货单位：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.reOrderUnit || '' }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            退货合同实际结算金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.actualAmount || 0 }}元
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            实际退款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.rrefundAmount || 0 }}元
          </div>
        </div>
      </div>
    </el-form>

    <div class="title">
      退换货合同分配记录
    </div>
    <el-table :data="tableDataReturn" border show-summary :summary-method="setSummaries">
      <el-table-column fixed type="index" width="50" label="序号" align="left" />
      <el-table-column prop="reNewContractNum" label="退货合同编号" align="left" />
      <el-table-column prop="reTelegraphicNum" label="电汇底单编号" align="left" />
      <el-table-column prop="reActualAmount" label="实际结算金额" align="right" header-align="left" />
      <el-table-column prop="reAssignedAmount" label="已分配金额" align="right" header-align="left" />
      <el-table-column label="已分配金额比例" align="right" header-align="left">
        <template slot-scope="{ row }">
          {{ row.reAssignedRatio }}%
        </template>
      </el-table-column>
      <el-table-column prop="reAssignBy" label="分配人" align="left" />
      <el-table-column prop="reAssignTime" label="分配日期" align="left" />
    </el-table>

    <div class="title">
      虚拟换货合同分配记录
    </div>
    <el-table :data="tableDataFictitious" border show-summary :summary-method="setSummaries">
      <el-table-column fixed type="index" width="50" label="序号" align="left" />
      <el-table-column prop="reNewContractNum" label="虚拟换货合同编号" align="left" />
      <el-table-column prop="reTelegraphicNum" label="电汇底单编号" align="left" />
      <el-table-column prop="reActualAmount" label="实际结算金额" align="right" header-align="left" />
      <el-table-column prop="reAssignedAmount" label="已分配金额" align="right" header-align="left" />
      <el-table-column label="已分配金额比例" align="right" header-align="left">
        <template slot-scope="{ row }">
          {{ row.reAssignedRatio }}%
        </template>
      </el-table-column>
      <el-table-column prop="reAssignBy" label="分配人" align="left" />
      <el-table-column prop="reAssignTime" label="分配日期" align="left" />
    </el-table>

    <div class="title">
      原合同分配记录
    </div>
    <el-table :data="tableDataOriginal" border show-summary :summary-method="setSummaries">
      <el-table-column fixed type="index" width="50" label="序号" align="left" />
      <el-table-column prop="reNewContractNum" label="原合同编号" align="left" />
      <el-table-column prop="reTelegraphicNum" label="电汇底单编号" align="left" />
      <el-table-column prop="reActualAmount" label="实际结算金额" align="right" header-align="left" />
      <el-table-column prop="reAssignedAmount" label="已分配金额" align="right" header-align="left" />
      <el-table-column label="已分配金额比例" align="right" header-align="left">
        <template slot-scope="{ row }">
          {{ row.reAssignedRatio }}%
        </template>
      </el-table-column>
      <el-table-column prop="reAssignBy" label="分配人" align="left" />
      <el-table-column prop="reAssignTime" label="分配日期" align="left" />
    </el-table>

    <div class="title">
      价外费用合同分配记录
    </div>
    <el-table :data="tableDataExtra" border show-summary :summary-method="setSummaries">
      <el-table-column fixed type="index" width="50" label="序号" align="left" />
      <el-table-column prop="reNewContractNum" label="价位费用合同编号" align="left" />
      <el-table-column prop="reTelegraphicNum" label="电汇底单编号" align="left" />
      <el-table-column prop="reActualAmount" label="实际结算金额" align="right" header-align="left" />
      <el-table-column prop="reAssignedAmount" label="已分配金额" align="right" header-align="left" />
      <el-table-column label="已分配金额比例" align="right" header-align="left">
        <template slot-scope="{ row }">
          {{ row.reAssignedRatio }}%
        </template>
      </el-table-column>
      <el-table-column prop="reAssignBy" label="分配人" align="left" />
      <el-table-column prop="reAssignTime" label="分配日期" align="left" />
    </el-table>

    <div style="margin-top:20px; display:flex; justify-content:flex-end;">
      <el-button type="default" @click="closeDoalog">
        取消分配
      </el-button>
      <el-button type="primary" :loading="isBtnLoading" @click="submitData">
        确认无误
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAssignInfo, saveDealtContractAssign } from '@/API/index.js';
import { numAdd } from '@/libs/util';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      formData: {},
      tableData: [],
      isBtnLoading: false
    };
  },

  computed: {
    tableDataReturn () {
      return this.tableData.filter(row => row.reContractType === '退货合同');
    },
    tableDataFictitious () {
      return this.tableData.filter(row => row.reContractType === '虚拟换货合同');
    },
    tableDataOriginal () {
      return this.tableData.filter(row => row.reContractType === '原合同');
    },
    tableDataExtra () {
      return this.tableData.filter(row => row.reContractType === '价外费用合同');
    }
  },

  methods: {
    openDialog (data) {
      this.isShow = true;
      this.isLoading = true;
      this.queryData(data);
    },

    closeDoalog () {
      this.tableData = [];
      this.isShow = false;
    },

    queryData (item) {
      getAssignInfo(item)
        .then(res => {
          this.isLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.formData = data.reContractVO;
            this.tableData = data.reContractAssignRecordList;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    setSummaries ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (column.label === '序号') {
          sums[index] = '合计';
        }
        if (column.label === '已分配金额') {
          sums[index] = data.reduce((pre, cur) => numAdd(cur.reAssignedAmount, pre), 0);
        }
        if (column.label === '已分配金额比例') {
          let count = data.reduce((pre, cur) => numAdd(cur.reAssignedRatio, pre), 0);
          sums[index] = Number(count) > 100 ? '100%' : `${count}%`;
        }
      });
      return sums;
    },

    submitData () {
      this.isBtnLoading = true;
      saveDealtContractAssign(this.tableData)
        .then(res => {
          this.isBtnLoading = false;
          let { status } = res.data;
          if (status === '200') {
            this.$message.success('分配成功');
            setTimeout(() => window.close(), 500);
          }
        })
        .catch(() => {
          this.isBtnLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrap{
  overflow: hidden;
  margin-bottom: 15px;
}

.title{
  margin: 12px 0 10px;
  font-size: 16px;
  font-weight: 500;
}
</style>
